export const DidGroupDeleteInfo = () => (
  <>
    <p>Please note that before deleting you have to</p>
    <p>- cancel any shared channels and</p>
    <p>- move existing DID’s in DID-Group to the Default DID-Group.</p>
  </>
);
